import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PrepareProjectReviewForm from './PrepareProjectReviewForm'
import PrepareProjectReviewTable from './PrepareProjectReviewTable'
import { searchProjectAllDetail, exportProjectAllDetail } from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import TableReport from '../../adminReport/tableReport/TableReport'
import {
  exportProjectInternalAudit,
  searchProjectInternalAudit,
} from '../../../redux/actions/PrepareProjectReview'

export default function PrepareProjectReviewWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const history = useHistory()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  useEffect(() => {
    // setDataTable(mockCallData)
  }, [])

  const handleCancel = () => {
    setValueNullField()
    setDataTable(null)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let request = {
      pageNumber: 1,
      pageSize: pagSize,
      projectCode: data.projectCode,
      projectName: data.projectName,
      contractNo: data.contractNo,
      projectStatus: data?.projectStatus || [],
      projectType: data?.projectType || [],
      projectIssue: data?.projectIssue || [],
      // budgetApprove: data.budgetApprove,
      budgetApproveStart: data.budgetApproveSta || null,
      budgetApproveEnd: data.budgetApproveEnd || null,
      projectGrade: data?.projectGrade || [],
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      periodLatest: data.periodLatest,
      periodTotal: data.periodTotal,
      firstNameProjectCoordinator: data.firstNameProjectCoordinator,
      lastNameProjectCoordinator: data.lastNameProjectCoordinator,
      department: data?.department || [],
      teamAudit: data.teamAudit,
      pointAudit: data.pointAudit,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      responsinatorTelephone: data.responsinatorTelephone,
      responsinatorEmail: data.responsinatorEmail,
      responsinatorIdCard: data.responsinatorIdCard,
      firstNameGrentree: data.firstNameGrentree,
      lastNameGrentree: data.lastNameGrentree,
      grentreeIdCard: data.grentreeIdCard,
      grentreeTelephone: data.grentreeTelephone,
      grentreeEmail: data.grentreeEmail,
      organization: data.organization,
      contactNo: data.contactNo,
      taxNo: data.taxNo,
      projectSettingArea: data?.projectSettingArea || [],
    }

    setCondition(data)
    handlePreviewReport(request)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      // setDataTable(mockSchema.model)
      const response = await searchProjectInternalAudit(request)
      // console.log('response', JSON.stringify(response))

      if (response.model) {
        setDataTable(response.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e?.response?.data?.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    // console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      projectCode: condition.projectCode,
      projectName: condition.projectName,
      contractNo: condition.contractNo,
      projectStatus: condition?.projectStatus || [],
      projectType: condition?.projectType || [],
      projectIssue: condition?.projectIssue || [],
      // budgetApprove: condition.budgetApprove,
      budgetApproveStart: condition.budgetApproveSta || null,
      budgetApproveEnd: condition.budgetApproveEnd || null,
      projectGrade: condition?.projectGrade || [],
      projectStartDate: condition.projectStartDate,
      projectEndDate: condition.projectEndDate,
      periodLatest: condition.periodLatest,
      periodTotal: condition.periodTotal,
      firstNameProjectCoordinator: condition.firstNameProjectCoordinator,
      lastNameProjectCoordinator: condition.lastNameProjectCoordinator,
      department: condition?.department || [],
      teamAudit: condition.teamAudit,
      pointAudit: condition.pointAudit,
      firstNameResponsinator: condition.firstNameResponsinator,
      lastNameResponsinator: condition.lastNameResponsinator,
      responsinatorTelephone: condition.responsinatorTelephone,
      responsinatorEmail: condition.responsinatorEmail,
      responsinatorIdCard: condition.responsinatorIdCard,
      firstNameGrentree: condition.firstNameGrentree,
      lastNameGrentree: condition.lastNameGrentree,
      grentreeIdCard: condition.grentreeIdCard,
      grentreeTelephone: condition.grentreeTelephone,
      grentreeEmail: condition.grentreeEmail,
      organization: condition.organization,
      contactNo: condition.contactNo,
      taxNo: condition.taxNo,
      projectSettingArea: condition?.projectSettingArea || [],
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handleOnClickExport = (data) => {
    console.log('handleOnClickExport ', data)

    let request = {
      projectCode: data.projectCode,
      projectName: data.projectName,
      contractNo: data.contractNo,
      projectStatus: data?.projectStatus || [],
      projectType: data?.projectType || [],
      projectIssue: data?.projectIssue || [],
      // budgetApprove: condition.budgetApprove,
      budgetApproveStart: data?.budgetApproveSta || null,
      budgetApproveEnd: data?.budgetApproveEnd || null,
      projectGrade: data?.projectGrade || [],
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      periodLatest: data.periodLatest,
      periodTotal: data.periodTotal,
      firstNameProjectCoordinator: data.firstNameProjectCoordinator,
      lastNameProjectCoordinator: data.lastNameProjectCoordinator,
      department: data?.department || [],
      teamAudit: data.teamAudit,
      pointAudit: data.pointAudit,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      responsinatorTelephone: data.responsinatorTelephone,
      responsinatorEmail: data.responsinatorEmail,
      responsinatorIdCard: data.responsinatorIdCard,
      firstNameGrentree: data.firstNameGrentree,
      lastNameGrentree: data.lastNameGrentree,
      grentreeIdCard: data.grentreeIdCard,
      grentreeTelephone: data.grentreeTelephone,
      grentreeEmail: data.grentreeEmail,
      organization: data.organization,
      contactNo: data.contactNo,
      taxNo: data.taxNo,
      projectSettingArea: data?.projectSettingArea || [],
    }
    console.log('request ', request)
    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportProjectInternalAudit(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลโครงการ`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      let errorJson = JSON.parse(await e?.response?.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleClickLinked = (versionid) => {
    sessionStorage.setItem('projectId', versionid)
    sessionStorage.setItem('param', '')

    const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.proposal.overview.overviewCoworker}`

    window.open(xurl, '_blank')
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.searchObject.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <PrepareProjectReviewForm
          schema={formSchema.searchObject}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          // handelPreview={onSubmit}
          clearValue={clearValue}
        />

        <hr />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema.searchObject.buttonText}
          onCancel={handleSubmit(handleCancel)}
          onSave={handleSubmit(onSubmit)}
        />
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <div style={{ marginTop: 10 }}>
            <TableReport
              schema={dataTable}
              headerHeightSize={40}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              onReload={handelGetSchemaOnReload}
              onClickExport={handleSubmit(handleOnClickExport)}
              onClickLinked={handleClickLinked}
            />
          </div>
          <br />
        </>
      )}
    </>
  )
}
